<template>
	<div>
		<ed-modal 
			:title="'Editar Conteúdo'" 
			:modal="showFormEdit" 
			:loadingSave="config.loading.save"
			:onSave="salvar"
			width="95%"
		>
			<div slot="modal-content" v-loading="config.loading.content">
				<el-tabs type="card" v-model="tagConfig">
					<el-tab-pane label="tab-editar" name="tab-editar">
						<span slot="label">
							<i class="fa fa-pencil-square-o"></i> Editar
						</span>
						<ed-form :data="formData" :config="config" :response="response" :itens="conteudoItems">
							<div slot="form-footer"></div>
						</ed-form>
					</el-tab-pane>

					<el-tab-pane label="tab-editar" name="tab-conteudo">
						<span slot="label">
							<i class="fa fa-search-plus"></i> Visualizar Conteúdo
						</span>
						<span v-html="formData.titulo" />
					</el-tab-pane>
				</el-tabs>
				
			</div>
		</ed-modal>

		<ed-table
			:onEdit="onEdit"
			:onSearch="getModeloConteudo"
			:tableHead="tableHead"
			:tableData="tableData"
			:loadingTable="config.loading.content "
			:pagination="pagination"
			:response="response"
		/>
	</div>
</template>

<script>

	import Rest from 'common/rest';
	import EdTable from 'common/table'
	import EdForm from 'common/form';
	import EdModal from 'common/modal';
	import FormItems  from './_form/conteudo-editar';

  	export default {
  		name:"exame-editar",
  		components: {EdForm,EdModal,EdTable},
		mixins:[Rest],
		props:{
            modelo:{
                type: Object,
                default: null
			},
        },
		watch: {
			'modelo.id'(){
				this.getModeloConteudo();
			},
			'formData.ocultar'(){
				this.config.disabled.fator_riscos = (this.formData.ocultar == 0);
				this.config.disabled.ocultar_texto = (this.formData.ocultar == 0);
			},
		},
  		data () {
		   	return {
				config:{
					tipo:[],
					click:{
						fator_riscos:this.getFatorRisco
					},
					loading:{
						save:false,
						content:false,
						fator_riscos:false,
					},
					disabled:{
						fator_riscos:true,
						ocultar_texto:true
					},
					list:{
						fator_riscos:[]
					}
				},
		   		formData:{
		   			id:0,
		   			titulo:null,
					ocultar:0,
					ocultar_texto:null,
		   			updated_at:null,
					usuario:null,
					fator_riscos:[]
		   		},
				response:{},
				pagination:{
				},
		   		tableHead:[
					{
		                key: 'titulo',
						sortable: true,
						label: 'Título',
					},
					{
		                key: 'updated_at',
						sortable: true,
						show_user:true,
						label: 'Atualização',
					},
		   		],
				tableData:[],
				conteudoItems:[],
				showFormEdit:false,
				tagConfig:'tab-editar'
			}
		},

		mounted() {
			this.getModeloConteudo();
			this.getFatorRisco();
			this.conteudoItems = FormItems;
		},

		methods: {

			onEdit(data){
				this.config.list.fator_riscos = [];
				this.tagConfig = 'tab-editar';

				this.formData = {
					id:data.id,
		   			titulo:data.titulo,
					ocultar:data.ocultar,
					ocultar_texto:data.ocultar_texto,
		   			updated_at:data.updated_at,
					usuario:data.usuario,
					fator_riscos:[]
				};

				this.showFormEdit = !this.showFormEdit;

				for (let i = 0; i < data.fator_riscos.length; i++) {
					const element = data.fator_riscos[i];
					this.config.list.fator_riscos.push(element)
					this.formData.fator_riscos.push(element.id);
				}
			},

			getFatorRisco(_search){

				this.config.loading.fator_riscos = true;
				this.config.list.fator_riscos  = [];
				
				this.get('fator-risco',{search:_search}).then((result)=>{

					result = result[0];

					this.config.loading.fator_riscos = false;

		            if(result.status == 200){
						this.config.list.fator_riscos = result.data.data;
		            }
	            });
			},

			getModeloConteudo: function(_search,_page,_pagination){

				if(!this.modelo)return;
				
				_pagination = (!_pagination ? 100 : _pagination);
				
				this.config.loading.content = true;
				this.response = {};

				this.get('ltcat/modelo/conteudo/'+this.modelo.id,{search:_search,page:_page,pagination:_pagination}).then((result)=>{

					result = result[0];
					this.response = result;

					this.config.loading.content  = false;

		             if(result.status == 200){
						
						if(result.status == 200){
							var
								data = result.data.data,
								tableData = [],
								pagination = result.data;

							for (var i = 0; i < data.length; i++) {

								var item = {
									'id': data[i].id,
									'titulo': (data[i].tipo == 0 ? '***' : data[i].titulo),
									'updated_at': this.toDate(data[i].updated_at),
									_data:data[i],
									options:{
										disable_delete:!this.validarPermissao(569),
										disable_edit:(!this.validarPermissao(569) || data[i].tipo != 0),
										style:'color:'+(data[i].ocultar == 1 ? 'red' : '')
									},
									buttons:[]
								};

								tableData.push(item);
							}

							console.log(pagination)
							this.pagination = pagination;
							this.tableData = tableData;
						}
		             }
	            });
			},

			salvar(){

				this.response = {};
				this.config.loading.save = true;

				this.post('ltcat/modelo/conteudo/'+this.modelo.id+'/editar',this.toFormUpload(this.formData)).then((result)=>{

					result = result[0];

					this.config.loading.save = false;
					this.response = result;

					if(result.status == 200){
						this.edMsg('Registro salvo com sucesso!');
						this.getModeloConteudo();
						this.showFormEdit = !this.showFormEdit;
					}

				});
			}
		}
  	}
</script>


// WEBPACK FOOTER //
// conteudo.vue?9f4fcfa6